const CLUB_MED_LAYER = 'clubMedLayer';

export function reset() {
  delete global.window[CLUB_MED_LAYER];
}

export function set(data) {
  if (!global.window[CLUB_MED_LAYER]) {
    global.window[CLUB_MED_LAYER] = [];
  }
  if (data) {
    global.window[CLUB_MED_LAYER].push(data);
  }
}

export function getDataLayer() {
  return global.window[CLUB_MED_LAYER] || [];
}
